export default function (close, vehicleId, mileage, keepers, vehicleSourced, editMileage, toaster, mileageSourced) {
    const vm = this;

    vm.mileage = Object.assign({}, mileage);
    vm.vehicleSourced = [];
    vm.keepers = keepers;
    vm.mileageSourced = [];

    /* --- */

    vm.closeModal = close;
    vm.edit = edit;

    /* --- */

    mileageSourced.then(x => {
        vm.mileageSourced = x;

        const relatedMileageSource = vm.mileageSourced.find(x => x.description === vm.mileage.source);
        if (relatedMileageSource) {
            vm.mileage.source = relatedMileageSource.id;
        }
    });

    /* --- */

    function edit() {
        editMileage(vehicleId, vm.mileage.id, vm.mileage)
        .then(() => {
            const relatedMileageSource = vm.mileageSourced.find(x => x.id === vm.mileage.source);
            if (relatedMileageSource) {
                vm.mileage.source = relatedMileageSource.description;
            }

            Object.assign(mileage, vm.mileage);

            toaster.success('Mileage successfully updated');
            close();
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/mileages/edit/editMileageCtrl.js